<div class="backup-list-container">
  <mat-table id="backup-list" #table [dataSource]="dataSource" [trackBy]="trackById">
    <ng-container matColumnDef="date" sticky>
      <mat-header-cell class="backup-datetime-column" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.DATE' | translate }}
      </mat-header-cell>
      <mat-cell class="backup-datetime-column" *matCellDef="let backup">
        <span class="backup-date">
          {{ backup.dateTime | date }}
        </span>
        <span class="backup-time">
          {{ backup.dateTime | date: 'h:mm a' }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="description">
      <mat-header-cell class="backup-desc-column" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.DESCRIPTION' | translate }}
      </mat-header-cell>
      <mat-cell class="backup-desc-column" *matCellDef="let backup">
        <div class="truncate-description" [matTooltip]="backup.displayDescription">
          {{ backup.displayDescription }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileSystemSize">
      <mat-header-cell class="size-column-cell" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.FILES' | translate }}
      </mat-header-cell>
      <mat-cell class="size-column-cell" *matCellDef="let backup; let i = index">
        <div [ngClass]="{ 'backup-size-diff': isHighlighted(i, 0) }">
          {{ backup.displayFileSystemSize | filesize }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="databaseSize">
      <mat-header-cell class="size-column-cell" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.DATABASE' | translate }}
      </mat-header-cell>
      <mat-cell class="size-column-cell" *matCellDef="let backup; let i = index">
        <div [ngClass]="{ 'backup-size-diff': isHighlighted(i, 1) }">
          {{ backup.displayDatabaseSize | filesize }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="posts">
      <mat-header-cell class="data-column-cell" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.POSTS' | translate }}
      </mat-header-cell>
      <mat-cell class="data-column-cell" *matCellDef="let backup; let i = index">
        <div [ngClass]="{ 'backup-diff': isHighlighted(i, 2) }">
          {{ backup.displayNPosts }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="pages">
      <mat-header-cell class="data-column-cell" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.PAGES' | translate }}
      </mat-header-cell>
      <mat-cell class="data-column-cell" *matCellDef="let backup; let i = index">
        <div [ngClass]="{ 'backup-diff': isHighlighted(i, 3) }">
          {{ backup.displayNPages }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="plugins">
      <mat-header-cell class="data-column-cell plugins-col" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.PLUGINS' | translate }}
      </mat-header-cell>
      <mat-cell class="data-column-cell plugins-col" *matCellDef="let backup; let i = index">
        @if (backup.hasPlugins) {
          <div
            (click)="showPluginDialog(backup, i)"
            [ngClass]="{ 'backup-diff': isHighlighted(i, 4) }"
            class="plugin-clickable"
            >
            <a>{{ backup.displayNPlugins }}</a>
          </div>
        } @else {
          <div [ngClass]="{ 'backup-diff': isHighlighted(i, 4) }">
            {{ backup.displayNPlugins }}
          </div>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="wpVersion">
      <mat-header-cell class="data-column-cell wp-version" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.WP_VERSION' | translate }}
      </mat-header-cell>
      <mat-cell class="data-column-cell wp-version" *matCellDef="let backup; let i = index">
        {{ backup.displayWPVersion }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="subsites">
      <mat-header-cell class="data-column-cell subsites" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.SUBSITES' | translate }}
      </mat-header-cell>
      <mat-cell class="data-column-cell subsites" *matCellDef="let backup">
        {{ isAfterCutoffDate(backup.dateTime) ? backup.displayActiveSubsiteCount + '/' + backup.displaySubscribedSubsiteCount : '-' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell class="actions-column-cell" *matHeaderCellDef></mat-header-cell>

      <mat-cell class="actions-column-cell" *matCellDef="let backup">
        @if (backup.validBackup) {
          <button
            class="restore-button"
            type="button"
            mat-button
            color="accent"
            [disabled]="!backup.validBackup || backupStatus !== 'done'"
            (click)="showRestoreSiteDialog(backup)"
            >
            {{ 'PAGES.BACKUPS.BUTTONS.RESTORE' | translate }}
          </button>
        } @else {
          @if (backup.inProgress) {
            <mat-spinner class="in-progress-spinner" mode="indeterminate" color="accent" diameter="36"></mat-spinner>
          } @else {
            <p class="mat-error">
              {{ 'PAGES.BACKUPS.FAILED.BACKUP_FAILED' | translate }}
            </p>
          }
        }


      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="header-row-backup-create">
      <mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length" class="backup-create-header">
        <div>
          <div>
            @if ((stagingEnabled$ | async) === false && isStaging) {
              <button type="button" mat-button color="accent" (click)="navigateToStagingPage()">
                {{ 'PAGES.BACKUPS.BUTTONS.ENABLE_STAGING' | translate }}
              </button>
            } @else {
              <button
                type="button"
                mat-button
                color="accent"
                [disabled]="(siteAvailable$ | async) === false"
                (click)="showBackupDialog()"
                >
                +
                {{ 'PAGES.BACKUPS.BUTTONS.CREATE_BACKUP_FROM' | translate: { env: getEnv() | translate } }}
              </button>
            }
          </div>
          @if (backupStatus !== 'done') {
            <div class="w-full">
              <div class="">
                <glxy-progress-bar [progress]="progress" color="primary" size="small" />
                <div class="text-center p-5">
                  @if (backupStatus === 'file-backup') {
                    {{
                    'PAGES.BACKUPS.STEPS.FILE_BACKUP' | translate
                    }}
                  }
                  @if (backupStatus === 'database-backup') {
                    {{
                    'PAGES.BACKUPS.STEPS.DATABASE_BACKUP' | translate
                    }}
                  }
                  @if (backupStatus === 'exporting') {
                    {{
                    'PAGES.BACKUPS.STEPS.EXPORTING' | translate
                    }}
                  }
                </div>
                @if (etaTime !== '') {
                  <div class="text-center p-5">
                    {{ 'PAGES.BACKUPS.STEPS.ETA' | translate }} {{ this.etaTime }}
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="footer-row-pro-upgrade-message">
      <mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length" class="backup-create-header">
        <app-backup-pro-upgrade (upgradeButtonClicked)="upgradeButtonClicked.emit()"></app-backup-pro-upgrade>
      </mat-footer-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-header-row *matHeaderRowDef="['header-row-backup-create']"></mat-header-row>
    @if (isExpress$ | async) {
      <ng-container class="express-rows-container">
        <mat-row
          class="backup-row"
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="{ 'failed-backup': !row.validBackup }"
        ></mat-row>
        <mat-footer-row *matFooterRowDef="['footer-row-pro-upgrade-message']"></mat-footer-row>
      </ng-container>
    } @else {
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ 'failed-backup': !row.validBackup }"
      ></mat-row>
    }
  </mat-table>

  @if (loading$ | async) {
    <mat-spinner class="total-table-spinner" color="accent" mode="indeterminate"></mat-spinner>
  }

  <mat-paginator
    #paginator
    (page)="changedPage($event)"
    [length]="numberOfBackups$ | async"
    [pageIndex]="0"
    [pageSizeOptions]="[10]"
  ></mat-paginator>
</div>
